<template>
  <div class="search-criteria-box">
    <h4 class="tit-search-type is-bgc-red400">棚板数</h4>
    <!-- <img src="/images/cmn/ico-board.png" class="img-fluid mx-auto" alt="" width="300" height="200"> -->
    <div class="search-radio-set">
      <template v-for="option in options">
        <input type="radio"
        :name="name"
        :id="`label5-${option.id}`"
        :key="`radio5-${option.id}`"
        :value="option.data"
        @change="updateValue(option.data, option.calc)"
        >
        <label :key="`label5-${option.id}`" :for="`label5-${option.id}`" v-html="option.value"></label>
    </template>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {},
    options: { type: Array },
    name: { type: String },
  },
  methods: {
    updateValue: function(value, multi) {
      this.$emit('BoardCalc', multi);
      this.$emit("input", value);
    }
  }
}
</script>